import { createBrowserHistory } from 'history';

/**
 * expose
 */

export default createBrowserHistory();
